import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import PNLogo from '@propertypal/shared/src/resources/logos/property-news-logo.svg?url';
import PPLogo from '@propertypal/shared/src/resources/logos/PropertyPalLogo.svg?url';
import { IFaq } from '@propertypal/shared/src/types/strapi';
import platform from '@propertypal/shared/src/utils/platform';
import FaqFooter from '@propertypal/web-app/src/components/footer/FaqFooter';
import Link from 'next/link';
import React from 'react';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Box } from '../layout';
import { MidHeading, TextLink } from '../typography';
import FaqContentContainer from './FaqContentContainer';
import { FaqContainer, FaqHeaderWrapper, FaqHeaderBg, FaqHeaderContainer, Logo } from './FaqPageContainer.style';

export interface FaqBreadCrumb {
  title: string | React.ReactNode;
  url?: string;
}

export interface FaqPageContainerProps {
  children?: React.ReactNode;
  hideContact?: boolean;
  breadcrumbs?: FaqBreadCrumb[];
  base?: boolean;
  relatedArticles?: IFaq[] | null;
  agent?: boolean;
}

const FaqPageContainer: React.FC<FaqPageContainerProps> = ({ children, ...props }) => {
  return (
    <>
      <FaqContainer>
        <FaqHeaderContainer>
          <FaqHeaderWrapper>
            <Link aria-label="Frequently Asked Questions" href="/" prefetch={false}>
              <Logo src={platform.select(PPLogo, PNLogo).src} alt={`${platform.title} Logo`} />
            </Link>
            <Box display="flex" flexDirection="column" gap={5} w="auto">
              <MidHeading fontSize={platform.select(undefined, 30)}>Frequently Asked Questions</MidHeading>
              <TextLink aria-label="Home Page" href="/" prefetch={false} fontSize={14} w="fit-content">
                <Box display="flex" alignItems="center" gap={5}>
                  <FontAwesomeIcon icon={faChevronLeft} size={14} />
                  <span>Back to Main {platform.title} Website</span>
                </Box>
              </TextLink>
            </Box>
          </FaqHeaderWrapper>
        </FaqHeaderContainer>
        <FaqHeaderBg />
        <FaqContentContainer {...props}>{children}</FaqContentContainer>
      </FaqContainer>
      <FaqFooter />
    </>
  );
};

export default FaqPageContainer;
